import { render, staticRenderFns } from "./AutomaticReferenceCheckCard.vue?vue&type=template&id=34334c0b"
import script from "./AutomaticReferenceCheckCard.vue?vue&type=script&lang=js"
export * from "./AutomaticReferenceCheckCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports